<script>
    import model from '../../stores/modelStore';
	import { projectSettings, acceptedFileUploadList } from "../../config";

	import Form from "../../components/Form.svelte";
	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
    import DropZone from '../../components/DropZone.svelte';
	import PageSection from "../../components/PageSection.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";

	export let pageTitle = null;
	export let persistUrl = null;

	let buttons = null;

    let id = 'fileUploader';
    let options = {
            url: "/api/file-upload?token=" + $model.registrationToken,
            acceptedFiles: acceptedFileUploadList,
            fileUploadToken: $model.registrationToken
        };

	document.title = pageTitle;

    const handleSubmit = async (e) => {
    	buttons.blockNext();

		let response = await model.saveModelAsync(persistUrl);

		if (!response.success) {
			console.log(response);
		} else {
			buttons.next();
		}

		buttons.unblock();
    };

    $model.documentList = $model.documentList || [];

</script>

<PageSection>
	<Form id="form-document-upload" on:submit={handleSubmit}>
		<FormRow class="justify-content-center confirmation-hide">
			<FormColumn>
				<h4 class="text-center">{@html projectSettings.classActionName}</h4>
				<h1 class="text-center">Please upload your documents</h1>
			</FormColumn>
		</FormRow>
	
		<hr class="primary" />

        <div class="confirmation-box-shadow">    
            <p>
                Please upload any supporting documents you may have.
            </p>

            <FormRow>
                <FormColumn>
                    <DropZone
                        {options}
                        {id}
					    message="<strong>Upload files for your registration</strong><br />Drop files here or click to upload."
                        bind:documentList={$model.documentList}>
                    </DropZone>
                </FormColumn>
            </FormRow>
        </div>
		
		<FormRow class="confirmation-hide">
			<FormColumn>
				<NavigationButtons bind:buttons
					disableNext={$model.documentList.length < 1}
					nextPageLabel={"Submit"} />
			</FormColumn>
		</FormRow>
	</Form>

</PageSection>
